module.exports = __webpack_public_path__ + "static/media/treatment_fix_sel.83c9f7e8.png";